import React from "react";
import {buildStandsShareRows} from "./standsShare";
import {getEquipmentGroups, getEquipmentTypes} from "../assets/constants";

/*
 * Иерархическая таблица доли стендов (ТЗ 237):
 * Товарная группа → вид продукции | значение стендов | Доля (% от всего).
 */
const StandsShareList = ({groupTypeStats, emptyText}) => {
    const {rows, grandTotal} = buildStandsShareRows(
        groupTypeStats,
        getEquipmentGroups(),
        getEquipmentTypes()
    )

    if (!grandTotal) {
        return emptyText ?
            <div style={{color: 'var(--vkui--color_text_secondary)', padding: 12}}>{emptyText}</div> : null
    }

    const th = {
        textAlign: 'left',
        padding: '8px 10px',
        borderBottom: '1px solid var(--vkui--color_separator_primary)',
        fontSize: 13,
        color: 'var(--vkui--color_text_secondary)',
    }
    const td = {
        padding: '8px 10px',
        borderBottom: '1px solid var(--vkui--color_separator_primary)',
        fontSize: 14,
        verticalAlign: 'top',
    }

    return (
        <table className="stands-share-table" style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
            <tr>
                <th style={th}></th>
                <th style={{...th, textAlign: 'right'}}>значение стендов</th>
                <th style={{...th, textAlign: 'right'}}>Доля</th>
            </tr>
            </thead>
            <tbody>
            {rows.map((group) => (
                <React.Fragment key={group.id}>
                    <tr>
                        <td style={{...td, fontWeight: 700}}>{group.name}</td>
                        <td style={{...td, textAlign: 'right', fontWeight: 700}}>{group.count}</td>
                        <td style={{...td, textAlign: 'right', fontWeight: 700}}>{group.share}</td>
                    </tr>
                    {(group.children || []).map((typeRow) => (
                        <tr key={typeRow.id}>
                            <td style={{...td, paddingLeft: 28}}>{typeRow.name}</td>
                            <td style={{...td, textAlign: 'right'}}>{typeRow.count}</td>
                            <td style={{...td, textAlign: 'right'}}>{typeRow.share}</td>
                        </tr>
                    ))}
                </React.Fragment>
            ))}
            <tr>
                <td style={{...td, fontWeight: 700, borderBottom: 'none'}}>ВСЕГО</td>
                <td style={{...td, textAlign: 'right', fontWeight: 700, borderBottom: 'none'}}>{grandTotal}</td>
                <td style={{...td, textAlign: 'right', fontWeight: 700, borderBottom: 'none'}}></td>
            </tr>
            </tbody>
        </table>
    )
}

export default StandsShareList
